import { getGap } from '@Components/BigBrowse/Model/Classes/GridCard';
import type {
  BrandConcessionSectionProductDM,
  MultiSectionFigmaLayout,
  SectionItemDM,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import {
  getProductCard,
  getProductTitleCard,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/productCards';
import {
  PRODUCT_SUBTITLE_HEIGHT,
  PRODUCT_SUBTITLE_MARGIN_TOP,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/shelfDisplay.figma';
import { distributeItemsIntoColumns } from '@Utils/miscUtils';

type DistributeProductsParams = {
  products: SectionItemDM['products'];
  viewData: ViewData;
  layout: MultiSectionFigmaLayout;
  numOfColumns?: number;
};

export const distributeProducts =
  (parentSection?: SectionItemDM) =>
  ({ products, viewData, layout, numOfColumns }: DistributeProductsParams) => {
    const getProductCards = (product: BrandConcessionSectionProductDM) => [
      getProductCard(product, viewData, parentSection?.id),
      getGap({
        width: viewData.columnWidth!,
        height: PRODUCT_SUBTITLE_MARGIN_TOP,
      }),
      getProductTitleCard({
        product,
        viewData,
        layout,
        section: parentSection,
      }),
    ];

    const gapFiller = () =>
      getGap({
        width: viewData.columnWidth!,
        height:
          viewData.columnWidth! +
          PRODUCT_SUBTITLE_HEIGHT +
          PRODUCT_SUBTITLE_MARGIN_TOP,
      });

    return distributeItemsIntoColumns(
      products.map(getProductCards),
      numOfColumns ?? viewData.layoutTable!.length,
      gapFiller
    );
  };
